export enum GeodataConstants {
  TOKEN_REQUEST = 'GEODATA_TOKEN_REQUEST',
  TOKEN_SUCCESS = 'GEODATA_TOKEN_SUCCESS',
  TOKEN_FAILURE = 'GEODATA_TOKEN_FAILURE',
}
